var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1229_8833",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1229_8833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.75C12.5 5.55109 12.421 5.36032 12.2803 5.21967C12.1397 5.07902 11.9489 5 11.75 5C11.5511 5 11.3603 5.07902 11.2197 5.21967C11.079 5.36032 11 5.55109 11 5.75H12.5ZM11 17.75C11 17.9489 11.079 18.1397 11.2197 18.2803C11.3603 18.421 11.5511 18.5 11.75 18.5C11.9489 18.5 12.1397 18.421 12.2803 18.2803C12.421 18.1397 12.5 17.9489 12.5 17.75H11ZM17.75 12.5C17.9489 12.5 18.1397 12.421 18.2803 12.2803C18.421 12.1397 18.5 11.9489 18.5 11.75C18.5 11.5511 18.421 11.3603 18.2803 11.2197C18.1397 11.079 17.9489 11 17.75 11V12.5ZM5.75 11C5.55109 11 5.36032 11.079 5.21967 11.2197C5.07902 11.3603 5 11.5511 5 11.75C5 11.9489 5.07902 12.1397 5.21967 12.2803C5.36032 12.421 5.55109 12.5 5.75 12.5V11ZM11 5.75V17.75H12.5V5.75H11ZM17.75 11H5.75V12.5H17.75V11Z",
    fill: "#28303F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.87cae170980b899ad91b528593094b36.svg";
export { ForwardRef as ReactComponent };